import { getStatus } from '@libs/network-utils';
import { FunctionEventTypeEnum, JsonPathEnum, TCommonData, TUseBehavior, TWidget } from '@libs/types';
import { useMemo } from 'react';
import { PROPERTY_PREFIX } from '@libs/utils';

export const useBehavior = <T extends TCommonData>(widget: TWidget<T>): TUseBehavior => {
    const { hasDisabledFunction, hasEnabledFunction, isEnabled, isDisabled, isHidden } = useMemo(() => {
        const hasDisabledFunction = !!(
            widget?.functions?.[FunctionEventTypeEnum.DISABLED] || widget?.functions?.[`${PROPERTY_PREFIX}${JsonPathEnum.IS_DISABLED}`]
        );
        const hasEnabledFunction = !!(widget?.functions?.[FunctionEventTypeEnum.ENABLED] || widget?.functions?.[`${PROPERTY_PREFIX}${JsonPathEnum.ENABLED}`]);
        const initEnabled = widget?.options?.enabled;
        const initIsDisabled = widget?.options?.isDisabled;
        const status = getStatus(initEnabled, initIsDisabled, hasEnabledFunction, hasDisabledFunction);
        return {
            isEnabled: status.enabled,
            isDisabled: status.isDisabled,
            hasDisabledFunction,
            hasEnabledFunction,
            isHidden: widget?.options?.isHide ?? false,
        };
    }, [widget?.functions, widget?.options?.enabled, widget?.options?.isDisabled, widget?.options?.isHide]);

    return {
        isDisabled: hasDisabledFunction ? isDisabled : hasEnabledFunction ? !isEnabled : isDisabled,
        isHidden,
    };
};
